export default function ({ addUtilities }) {
  const dynamicHeightUtilities = {};
  const dynamicMinHeightUtilities = {};
  const dynamicMaxHeightUtilities = {};

  for (let i = 0; i <= 100; i++) {
    dynamicHeightUtilities[`.h-dynamic-${i}`] = {
      height: `calc(var(--viewport-height-unit) * ${i})`,
    };
    dynamicMinHeightUtilities[`.min-h-dynamic-${i}`] = {
      minHeight: `calc(var(--viewport-height-unit) * ${i})`,
    };
    dynamicMaxHeightUtilities[`.max-h-dynamic-${i}`] = {
      maxHeight: `calc(var(--viewport-height-unit) * ${i})`,
    };
  }

  addUtilities(dynamicHeightUtilities, ['responsive']);
  addUtilities(dynamicMinHeightUtilities, ['responsive']);
  addUtilities(dynamicMaxHeightUtilities, ['responsive']);
}
